/* eslint-disable default-case,eqeqeq,no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('variablesEditor', [
  '$timeout',
  '$translate',
  function ($timeout, $translate) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./variables-editor.html'),

      replace: true,

      scope: {
        items: '=ngModel',
      },

      link(scope, element, attrs) {
        let startSortIndex = 0;
        let endSortIndex = 0;

        const $sortContainer = element.find('.variables-editor-sortable');

        scope.key = attrs.key || 'key';
        scope.value = attrs.value || 'value';
        scope.type = attrs.type || '';
        scope.showRemove = !(attrs.hideRemove == 'true');
        scope.showAdd = !(attrs.hideAdd == 'true');
        scope.showUndo = attrs.showUndo == 'true';
        scope.disableKey = attrs.disableKey == 'true';
        scope.disableSort = attrs.disableSort == 'true';
        scope.readonlyValue = attrs.readonlyValue == 'true';
        scope.usePackageDefault = attrs.usePackageDefault == 'true';

        $translate(attrs.emptyMessage || 'variables-editor.labels.empty-list').then(function (message) {
          scope.emptyMessage = message;
        });

        const changeItemPosition = function (fromIndex, toIndex) {
          scope.items.splice(toIndex, 0, scope.items.splice(fromIndex, 1)[0]);

          scope.$apply();
        };

        const startSortHandle = function (event, ui) {
          startSortIndex = ui.item.index();
        };

        const endSortHandle = function (event, ui) {
          endSortIndex = ui.item.index();

          changeItemPosition(startSortIndex, endSortIndex);
        };

        $sortContainer.sortable({
          handle: '.variables-editor-move:not(.locked)',
          cancel: '',
          item: '.variables-editor-row',
          axis: 'y',
          // containment: '.variables-editor',
          placeholder: 'variables-editor-highlight',
          start: startSortHandle,
          update: endSortHandle,
        });

        scope.remove = function (index) {
          element.find('.variables-editor-row').eq(index).remove();
          scope.items.splice(index, 1);

          element.trigger('item.removed');
        };

        scope.add = function () {
          const newItem = {};

          if (scope.showKey) newItem[scope.key] = '';
          if (scope.showValue) newItem[scope.value] = '';
          if (scope.showDataType) newItem.data_type = 'string';

          scope.items.push(newItem);

          element.trigger('item.added');
        };

        scope.addNasted = function () {
          element.trigger('item.nasted');
        };

        scope.copyKeyToValue = function (item) {
          item[scope.value] = item[scope.key];
        };

        scope.mark = function ($event, cssClass) {
          angular.element($event.target).closest('.variables-editor-row').addClass(cssClass);
        };

        scope.removeMark = function ($event, cssClass) {
          angular.element($event.target).closest('.variables-editor-row').removeClass(cssClass);
        };

        scope.$watch(
          'items',
          function () {
            element.trigger('item.changed');
          },
          true,
        );

        scope.setDefault = function (item, value) {
          item[value] = item.default;
          angular.element('.tooltip').remove();
        };
      },
      controller: [
        '$scope',

        function ($scope) {
          $scope.showKey = true;
          $scope.showValue = true;
          $scope.showAdd = true;
          $scope.showDataType = false;
          $scope.showRemove = true;
          $scope.showUndo = false;
          $scope.disableSort = false;
          $scope.disableKey = false;
          $scope.readonlyValue = false;
          $scope.emptyMessage = '';
          $scope.usePackageDefault = false;
        },
      ],
    };
  },
]);
